import { useCallback, useRef } from 'react';
import debounce from 'lodash.debounce';
import cn from 'classnames';
import { useDispatch } from 'react-redux';

import DoubleSlider from 'components/common/DoubleSlider';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { updatePriceRange } from 'actions/search';

import css from 'styles/components/search/priceSlider.scss';

export const MIN_LABEL = 'min_price';
export const MAX_LABEL = 'max_price';

export const PriceSlider = ({ className, isExpanded, selectedRange, resultsRange, updatePriceRange }) => {
  const dispatch = useDispatch();
  const { min: selectedMin, max: selectedMax } = selectedRange;
  const rangeMin = Math.floor(resultsRange.min);
  const rangeMax = Math.ceil(resultsRange.max);
  const sliderRef = useRef();

  // Default in case of null/undefined
  const minDefaultValue = typeof selectedMin === 'number' ? selectedMin : rangeMin;
  const maxDefaultValue = typeof selectedMax === 'number' ? selectedMax : rangeMax;

  const deboucedUpdatePriceRange = useCallback(debounce(priceRange => dispatch(updatePriceRange(priceRange)), 800), []);

  const onChange = useCallback(priceRange => {
    deboucedUpdatePriceRange(priceRange);
  }, [deboucedUpdatePriceRange]);

  return (
    <div className={cn(className, css.container, { [css.hidden]: !isExpanded })}>
      <DoubleSlider
        ref={sliderRef}
        minLabel={MIN_LABEL}
        maxLabel={MAX_LABEL}
        minLimit={minDefaultValue}
        maxLimit={maxDefaultValue}
        minDefault={rangeMin}
        maxDefault={rangeMax}
        onChange={onChange}
      />
    </div>
  );
};

PriceSlider.defaultProps = {
  updatePriceRange
};

export default withErrorBoundary('PriceSlider', PriceSlider);
